import { API } from '../config/api';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const API_LOCAL = BACKEND_URL ? `${BACKEND_URL}/api` : '/api';

export const setAuthToken = (token) => {
  if (token) {
    localStorage.setItem('lee_token', token);
  } else {
    localStorage.removeItem('lee_token');
  }
};

export const getAuthToken = () => {
  return localStorage.getItem('lee_token');
};

export const setUser = (user) => {
  localStorage.setItem('lee_user', JSON.stringify(user));
};

export const getUser = () => {
  const user = localStorage.getItem('lee_user');
  return user ? JSON.parse(user) : null;
};

export const logout = () => {
  localStorage.removeItem('lee_token');
  localStorage.removeItem('lee_user');
};

export const isAuthenticated = () => {
  return !!getAuthToken();
};

export const getAuthHeaders = () => {
  const token = getAuthToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// Validate token by checking with backend
export const validateToken = async () => {
  const token = getAuthToken();
  if (!token) return false;

  try {
    const response = await fetch(`${API}/auth/me`, {
      headers: getAuthHeaders()
    });
    
    if (response.ok) {
      const user = await response.json();
      setUser(user);
      return true;
    } else {
      // Token is invalid, clear it
      logout();
      return false;
    }
  } catch (error) {
    console.error('Token validation failed:', error);
    // Don't logout on network errors, just return false
    return false;
  }
};
